export default __webpack_public_path__ + "fd83145aeb2f6931cdf411364c2c6b0a.svg";